import React from 'react'
import { IntlProvider } from 'react-intl'
import messagesEn from '../translations/en.json'
import messagesEs from '../translations/es.json'
import messagesCf from '../translations/cf.json'

// Setup messages
const messages = {
  en: messagesEn,
  es: messagesEs,
  fr: messagesCf,
}

function IntlProviderWrapper ({ children, locale = 'en' }) {
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  )
}

export default IntlProviderWrapper
